import { ListItemIcon, ListItemText } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import { StyledList, StyledListItem } from '@/components/AssetsPage/PopoverList';
import { pluralize } from '@/utils/format';

export const BulkActionsMenuContent = ({
  itemCount,
  canMove,
  canDelete,
  onMoveClick,
  onDeleteClick,
}: {
  itemCount: number;
  canMove?: boolean;
  canDelete?: boolean;
  onMoveClick: () => void;
  onDeleteClick: () => void;
}) => (
  <StyledList sx={{ padding: 0 }}>
    {canMove && (
      <StyledListItem onClick={onMoveClick}>
        <ListItemIcon>
          <DriveFileMoveIcon sx={{ fontSize: '18px', color: 'success.main' }} />
        </ListItemIcon>
        <ListItemText>Move {pluralize(itemCount, 'item', 'items')}</ListItemText>
      </StyledListItem>
    )}
    {canDelete && (
      <StyledListItem onClick={onDeleteClick}>
        <ListItemIcon>
          <DeleteIcon sx={{ fontSize: '18px' }} color='error' />
        </ListItemIcon>
        <ListItemText>Delete {pluralize(itemCount, 'item', 'items')}</ListItemText>
      </StyledListItem>
    )}
  </StyledList>
);
